export default __webpack_public_path__ + "static/media/GF_POSTER_GROUP_04.9b4daf5c.jpg";